import {Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ModalComponent} from '@core/modal.component';
import {ProductItem} from '@entities/menu.entity';
import Swiper from 'swiper';
import {ModalService} from '@services/modal.service';
import {CatalogService} from '@models/catalog.service';
import {ProductModalComponent} from '@components/modals/product/item';
import {AppService} from '@services/app.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-product-group-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})

export class ProductGroupModalComponent extends ModalComponent implements OnInit, OnDestroy  {
  @Input() products: ProductItem[];
  productId: number = null;
  imageLoaded = false;
  isLoaded: boolean[] = [];
  swiper!: Swiper;
  isInitSlider = false;
  @ViewChild('slider1') slider1: ElementRef;
  @ViewChild('slider2') slider2: ElementRef;
  private modalService = inject(ModalService);
  private catalogService = inject(CatalogService);
  private appService = inject(AppService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit() {
    // console.log({products: this.products});
  }

  ngOnDestroy(): void {}

  onImageLoad() {
    // Изображение успешно загрузилось, скрываем лоадер
    this.imageLoaded = true;
  }

  onImagesLoad(index: number) {
    this.isLoaded[index] = true;
  }

  init(element: any) {
    this.swiper = element.detail[0];
    const currentId = this.products.findIndex(item => item.id === this.productId);
    setTimeout(()=> {
      this.swiper.slideTo(currentId, 0);
      this.isInitSlider = true;
    }, 200);
  }

  openComboItemModal(id: number) {
    const product = this.catalogService.productItems.find(obj => obj.id === id);
    if (product) {
      this.modalService.openModal(ProductModalComponent,
        {
          product,
          customBreakpoints: [0, 0.90]}
        );
    } else {
      console.log('Данного продукта нет в каталоге');
    }
  }

  clearedText(text: string) {
    return  this.sanitizer.bypassSecurityTrustHtml(text) as SafeHtml;
  }
}
